<template>
  <PC v-if="!isNemoApp"/>
  <H5 v-else/>
</template>
<script>
import PC from './pc'
import H5 from './h5'
export default {
  components: {
    PC,
    H5
  }
}
</script>
<style lang="scss" scoped>
</style>
